import { useT } from '../context/LocaleContext';

export default function PoweredBy() {
  const t = useT();
  return (
    <p className="powered">
      {t('common.poweredBy')}
      <img src="/futapp.png" alt="FutApp" />
    </p>
  );
}
